import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGUAGES } from "../constants/languages";

import ja from "./ja.json";
import en from "./en.json";
import tw from "./tw.json";

const resources = {
  ja: {
    translation: ja,
  },
  en: {
    translation: en,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: LANGUAGES.EN,
  // t() が null を返さないようにする（型定義 react-i18next.d.ts と揃える）
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
